export default {
  A: 'Automatic',
  M: 'Manual',
  T: 'Tiptronics',
  CVT: 'CVT',
  DSG: 'DSG'
}
